module.exports = __webpack_public_path__ + "assets/img/01-6cfac8e4.jpg";